













































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import basicPage from "@/layouts/basicPage.vue";
import AppConsts from "@/lib/appconst";
import ajaxHelperInstance from "@/lib/ajaxhelper";

@Component({
  components: {basicPage}
})
export default class allTrain extends basicPage {
  customActiveKey = '0'
  data: Array<Object> = [];

  handleTabClick(e) {
    this.customActiveKey = e;
  }

  pagination = {
    ...AppConsts.pagination,
    onChange: (current) => {
      this.pagination.current = current;
      this.loadData();
    }, onShowSizeChange: (current, pageSize) => {
      this.pagination.pageSize = pageSize;
      this.pagination.current = current;
      this.loadData();
    }
  };

  parameters = {
    keyWords: '',
    currentPage: this.pagination.current,
    pageSize: this.pagination.pageSize,
    status: null
  };


  loadData() {
    let self = this;
    this.parameters.currentPage = this.pagination.current;
    this.parameters.pageSize = this.pagination.pageSize;
    const queryParameters = {...this.parameters};
    ajaxHelperInstance.get('/web/meeting/search/getMyMeettingList', queryParameters, undefined, this).then((res) => {
      self.data = res.data.data.list || [];
      self.pagination.total = res.data.data.total;
    })
  }


  setKeywordsAndLoad(keywords) {
    this.parameters.keyWords = keywords;
    this.pagination.current = 1;
    this.loadData();
  }

  getThemeImgUrl(obj) {
    let url = obj.ztimg;
    if (url == undefined || url == null) {
      url = "/img/training/trainBack.svg"
    } else {
      url = AppConsts.fileResourceUrl + url;
    }
    return url;
  }


  getPXImageUrl(item) {
    let ret = ''
    switch (item.pxstatus) {
      case 1: { //报名未开始
        ret = '/img/training/wks.png';
        break;
      }
      case 2: { //报名中
        ret = '/img/training/zzbm.png';
        break;
      }
      case 3: { //报名结束
        ret = '/img/training/yjs.png';
        break;
      }
      case 4: { //培训结束
        ret = '/img/training/pxjs.png';
        break;
      }
    }
    return ret;
  }

  viewTrain(item) {
    this.$router.push({
      name: 'trainDetail',
      params: {
        trainId: item.pxid
      }
    })
  }

  mounted() {
    this.loadData();
  }
}
